import { Link } from "wouter";

export default function NotFound() {
  return (
    <>
      <title>Page not found | TLC Associates</title>
      <meta name="robots" content="noindex" />
      <section className="flex min-h-[70vh] w-full items-center justify-center bg-[#f7f3ed] px-4 py-20">
        <div className="w-full max-w-2xl rounded-2xl border border-gray-100 bg-white p-10 text-center shadow-sm md:p-14">
          <p className="mb-3 font-bold uppercase tracking-[0.18em] text-[#c84060]">
            Error 404
          </p>
          <h1 className="mb-6 text-4xl text-[#1a3a1a] md:text-5xl">
            Page not found
          </h1>
          <p className="mx-auto max-w-xl text-lg leading-relaxed text-gray-700">
            The page you requested may have moved or no longer exists. Use one
            of the links below to continue exploring TLC Associates.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link href="/" className="rounded-lg bg-[#1a3a1a] px-6 py-3 font-semibold text-white">
              Home
            </Link>
            <Link href="/#services" className="rounded-lg border-2 border-[#1a3a1a] px-6 py-3 font-semibold text-[#1a3a1a]">
              Services
            </Link>
            <Link href="/contact" className="rounded-lg border-2 border-[#1a3a1a] px-6 py-3 font-semibold text-[#1a3a1a]">
              Contact
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
